import React from "react";
import { motion } from "framer-motion";

const HamburgerIcon = ({ isOpen, onClick, className = "" }) => {
  // Define hamburger line thickness and spacing
  const lineHeight = 2;
  const spacing = 6;
  const topLineY = 0;
  const middleLineY = topLineY + lineHeight + spacing;
  const bottomLineY = middleLineY + lineHeight + spacing;

  // Calculate the center point for rotation
  const centerY = middleLineY + lineHeight / 2;

  return (
    <button
      className={`lg:hidden p-2 text-brandPrimary hover:text-brandAccent transition-colors z-10 ${className}`}
      onClick={onClick}
      aria-label={isOpen ? "Close menu" : "Open menu"}
    >
      <div className="relative w-6 h-6">
        {/* Top line */}
        <motion.span
          className="absolute bg-current rounded-full w-6"
          style={{
            height: `${lineHeight}px`,
            top: `${topLineY}px`,
            transformOrigin: "center",
          }}
          animate={{
            y: isOpen ? centerY - topLineY - lineHeight / 2 : 0,
            rotate: isOpen ? 45 : 0,
          }}
          transition={{ duration: 0.3 }}
        />

        {/* Middle line */}
        <motion.span
          className="absolute bg-current rounded-full w-6"
          style={{
            height: `${lineHeight}px`,
            top: `${middleLineY}px`,
          }}
          animate={{
            opacity: isOpen ? 0 : 1,
          }}
          transition={{ duration: 0.3 }}
        />

        {/* Bottom line */}
        <motion.span
          className="absolute bg-current rounded-full w-6"
          style={{
            height: `${lineHeight}px`,
            top: `${bottomLineY}px`,
            transformOrigin: "center",
          }}
          animate={{
            y: isOpen ? centerY - bottomLineY - lineHeight / 2 : 0,
            rotate: isOpen ? -45 : 0,
          }}
          transition={{ duration: 0.3 }}
        />
      </div>
    </button>
  );
};

export default HamburgerIcon;
